// extracted by mini-css-extract-plugin
module.exports = {"imageList":"ImageList_imageList__8Hia8","headline":"ImageList_headline__C12mJ"};